export const CHECKBOX_SELECTION_MODE =
	'state.actions.cards.checkbox-selection-mode.CHECKBOX_SELECTION_MODE' as const;

export type CheckboxSelectionModeAction = {
	type: typeof CHECKBOX_SELECTION_MODE;
	payload: {
		isCheckboxSelectionMode: boolean;
	};
};

export const setCheckboxSelectionMode = (
	isCheckboxSelectionMode: boolean,
): CheckboxSelectionModeAction => ({
	type: CHECKBOX_SELECTION_MODE,
	payload: {
		isCheckboxSelectionMode,
	},
});

export type Action = CheckboxSelectionModeAction;
